import { render } from "./SideBar.vue?vue&type=template&id=c4e244f2"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=c4e244f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__